module.exports = __webpack_public_path__ + "img/ly.cb3019fb.png";